import React from 'react'
import PropTypes from 'prop-types'
import { BlurCont } from 'Layout'

// import css from './styles.js'
import { _BrokrageAndMLSCont } from './styles'


const BrokrageAndMLS = ({ listing, isLocked }) => (
  <BlurCont blur={isLocked}>
    {
      listing &&
        <_BrokrageAndMLSCont>
          <div>
            Broker: {listing.brokerage || ' N/A'}
          </div>
          <div>
            MLS<sup>®</sup>#: {listing.mls_number ? listing.mls_number : 'N/A'}
          </div>
        </_BrokrageAndMLSCont>
    }
  </BlurCont>
)


BrokrageAndMLS.propTypes = {
  listing: PropTypes.shape({
    brokerage: PropTypes.string,
    mls_number: PropTypes.string,
  }),
  isLocked: PropTypes.bool,
}

export default BrokrageAndMLS
